import { useState, useEffect } from "react";
import client from "libs/client";

export type SelectOption = {
    value: number | string;
    label: string;
};

export const useVideoSourceOptions = () => {
    const [leagueOptions, setLeagueOptions] = useState<SelectOption[]>([]);
    const [teamOptions, setTeamOptions] = useState<SelectOption[]>([]);
    const [countryOptions, setCountryOptions] = useState<SelectOption[]>([]);

    const { data: teamOptionsData, isLoading: isTeamOptionsLoading } = client.getTeamsForDropdown.useQuery({
        queryKey: ['teamOptions']
    });

    const { data: leagueOptionsData, isLoading: isLeagueOptionsLoading } = client.getLeaguesForDropdown.useQuery({
        queryKey: ['leagueOptions']
    });

    const { data: countryOptionsData, isLoading: isCountryOptionsLoading } = client.getCountriesForDropdown.useQuery({
        queryKey: ['countryOptions']
    });

    useEffect(() => {
        if (teamOptionsData?.data) {
            setTeamOptions(teamOptionsData.data.map(team => ({
                value: team.id ?? 0,
                label: team.label ?? ''
            })));
        }
    }, [teamOptionsData]);

    useEffect(() => {
        if (leagueOptionsData?.data) {
            setLeagueOptions(leagueOptionsData.data.map(league => ({
                value: league.id ?? 0,
                label: league.label ?? ''
            })));
        }
    }, [leagueOptionsData]);

    useEffect(() => {
        if (countryOptionsData?.data) {
            setCountryOptions(countryOptionsData.data
                .filter(country => country.label)
                .map(country => ({
                    value: country.label!,
                    label: country.label!
                })))
        }
    }, [countryOptionsData])

    return {
        leagueOptions,
        teamOptions,
        countryOptions,
        isTeamOptionsLoading,
        isLeagueOptionsLoading,
        isCountryOptionsLoading
    };
}; 